"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8508],{

/***/ 74157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ RoundedButton; }
/* harmony export */ });
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42992);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11496);


var RoundedButton = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return {
        borderRadius: "5em",
        "&.themeOutline": {
            width: "100%",
            borderColor: theme.palette.primary.main
        },
        "&.themeOutline:hover": {
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main
        },
        "&.qnaireSaveProgress:disabled": {
            borderColor: "#b5b6b7"
        },
        "&.qnaireSubmit": {
            width: "100%"
        },
        "&.addItem": {
            backgroundColor: "#096532",
            paddingLeft: 15,
            color: "#FFFFFF",
            size: "small"
        },
        "&.addItem:hover": {
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main
        },
        "&.delete": {
            color: theme.palette.secondary.main,
            borderColor: theme.palette.secondary.main
        },
        "&.delete:hover": {
            color: theme.palette.secondary.main,
            borderColor: theme.palette.secondary.main
        },
        "&.contrast": {
            color: theme.palette.primary.contrastText
        }
    };
});


/***/ }),

/***/ 44612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ SlugLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var SlugLink = function(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var slug = router.query.slug;
    var href = props.href, alias = props.as;
    if (typeof slug === "string") {
        if (typeof href === "string") {
            href = "/".concat(slug).concat(href);
        }
        if (typeof alias === "string") {
            alias = "/".concat(slug).concat(alias);
        }
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], _objectSpread({}, props, {
        href: href,
        as: alias
    })));
};


/***/ }),

/***/ 88508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ DashboardLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@mui/material/AppBar/AppBar.js + 1 modules
var AppBar = __webpack_require__(42293);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(50122);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Toolbar/Toolbar.js
var Toolbar = __webpack_require__(83808);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(54799);
// EXTERNAL MODULE: ./node_modules/downloadjs/download.js
var download = __webpack_require__(33729);
var download_default = /*#__PURE__*/__webpack_require__.n(download);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 2 modules
var useTranslation = __webpack_require__(4374);
// EXTERNAL MODULE: ./node_modules/@mui/material/Popover/Popover.js
var Popover = __webpack_require__(90103);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(63931);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(48885);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(59334);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(23972);
// EXTERNAL MODULE: ./src/hooks/useSettings.ts
var useSettings = __webpack_require__(10901);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(82066);
;// CONCATENATED MODULE: ./src/icons/English.tsx


var English = (0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
    width: "20",
    height: "36",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            clipPath: "url(#clip0)",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    width: "36",
                    height: "36",
                    fill: "none"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M0 9V27H36V9H0Z",
                    fill: "#012169"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M0 9L36 27L0 9ZM36 9L0 27L36 9Z",
                    fill: "black"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M13.9754 18L-0.804688 10.61L0.805282 7.39005L18.0003 15.9876L35.1953 7.39005L36.8053 10.61L22.0252 18L36.8053 25.39L35.1953 28.61L18.0003 20.0125L0.805282 28.61L-0.804688 25.39L13.9754 18Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M0 9L36 27L0 9ZM36 9L0 27L36 9Z",
                    fill: "black"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.3168 17.9999L-0.536621 10.0732L0.536692 7.92661L18 16.6583L35.4634 7.92661L36.5367 10.0732L20.6833 17.9999L36.5367 25.9266L35.4634 28.0732L18 19.3416L0.536692 28.0732L-0.536621 25.9266L15.3168 17.9999Z",
                    fill: "#C8102E"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M18 9V27V9ZM0 18H36H0Z",
                    fill: "black"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M21 21V27H15V21H0V15H15V9H21V15H36V21H21Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M18 9V27V9ZM0 18H36H0Z",
                    fill: "black"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.8 19.8V27H16.2V19.8H0V16.2H16.2V9H19.8V16.2H36V19.8H19.8Z",
                    fill: "#C8102E"
                })
            ]
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                id: "clip0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    width: "36",
                    height: "36",
                    fill: "white"
                })
            })
        })
    ]
}), "English");
/* harmony default export */ var icons_English = (English);

;// CONCATENATED MODULE: ./src/icons/French.tsx


var French = (0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "36",
    viewBox: "0 0 3020 2020",
    children: [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
            fill: "rgb(0%,14%,58%)",
            x: "0",
            y: "0",
            width: "1010",
            height: "2000"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
            fill: "rgb(97%,97%,97%)",
            x: "1000",
            y: "0",
            width: "1010",
            height: "2000"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
            fill: "rgb(93%,16%,22%)",
            x: "2000",
            y: "0",
            width: "1000",
            height: "2000"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
            fill: "none",
            stroke: "rgb(55%,55%,55%)",
            strokeWidth: "10",
            x: "0",
            y: "0",
            width: "3000",
            height: "2000"
        })
    ]
}), "French");
/* harmony default export */ var icons_French = (French);

;// CONCATENATED MODULE: ./src/components/dashboard/LanguagePopover.tsx








function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var languageOptions = {
    en: {
        code: "en",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_English, {}),
        label: "English"
    },
    fr: {
        code: "fr",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_French, {}),
        label: "Fran\xe7ais"
    }
};
var LanguagePopover = function() {
    var ref = (0,useSettings/* useSettings */.r)(), settings = ref.settings, saveSettings = ref.saveSettings;
    var anchorRef = react.useRef(null);
    var i18n = (0,useTranslation/* useTranslation */.$)().i18n;
    var ref1 = _slicedToArray(react.useState(false), 2), open = ref1[0], setOpen = ref1[1];
    var handleOpen = function() {
        setOpen(true);
    };
    var handleClose = function() {
        setOpen(false);
    };
    var handleChangeLanguage = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(language) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return i18n.changeLanguage(language);
                    case 2:
                        saveSettings(_objectSpread({}, settings, {
                            language: language
                        }));
                        setOpen(false);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleChangeLanguage(language) {
            return _ref.apply(this, arguments);
        };
    }();
    var _language;
    var selectedOption = languageOptions[(_language = settings.language) !== null && _language !== void 0 ? _language : i18n.language];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                onClick: handleOpen,
                ref: anchorRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        height: 36,
                        width: 36,
                        "& svg": {
                            width: "100%"
                        }
                    },
                    children: selectedOption.icon
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
                anchorEl: anchorRef.current,
                anchorOrigin: {
                    horizontal: "center",
                    vertical: "bottom"
                },
                keepMounted: true,
                onClose: handleClose,
                open: open,
                PaperProps: {
                    sx: {
                        width: 240
                    }
                },
                children: Object.values(languageOptions).map(function(language) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                        onClick: _asyncToGenerator(runtime_default().mark(function _callee() {
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        return _ctx.abrupt("return", handleChangeLanguage(language.code));
                                    case 1:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        })),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    children: languageOptions[language.code].icon
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                primary: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    color: "textPrimary",
                                    variant: "subtitle2",
                                    children: languageOptions[language.code].label
                                })
                            })
                        ]
                    }, language.code);
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/components/RoundedButton.tsx
var RoundedButton = __webpack_require__(74157);
// EXTERNAL MODULE: ./node_modules/@mui/material/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(49990);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(69661);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(42992);
// EXTERNAL MODULE: ./node_modules/notistack/dist/notistack.esm.js + 1 modules
var notistack_esm = __webpack_require__(56254);
// EXTERNAL MODULE: ./node_modules/@mui/material/Switch/Switch.js + 1 modules
var Switch = __webpack_require__(45843);
// EXTERNAL MODULE: ./src/constants/themes.ts
var themes = __webpack_require__(24742);
;// CONCATENATED MODULE: ./src/icons/Moon.tsx


var Moon = (0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"
    })
}), "Moon");
/* harmony default export */ var icons_Moon = (Moon);

;// CONCATENATED MODULE: ./src/icons/Sun.tsx


var Sun = (0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        d: "M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z",
        clipRule: "evenodd"
    })
}), "Sun");
/* harmony default export */ var icons_Sun = (Sun);

;// CONCATENATED MODULE: ./src/components/ThemeSwitcher.tsx







function ThemeSwitcher_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ThemeSwitcher_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ThemeSwitcher_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ThemeSwitcher = function() {
    var ref = (0,useSettings/* useSettings */.r)(), settings = ref.settings, saveSettings = ref.saveSettings;
    var handleSwitch = function() {
        if (settings.theme === themes/* THEMES.LIGHT */.y.LIGHT) {
            saveSettings(ThemeSwitcher_objectSpread({}, settings, {
                theme: themes/* THEMES.DARK */.y.DARK
            }));
        } else if (settings.theme === themes/* THEMES.DARK */.y.DARK) {
            saveSettings(ThemeSwitcher_objectSpread({}, settings, {
                theme: themes/* THEMES.LIGHT */.y.LIGHT
            }));
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            display: "flex",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Sun, {
                fontSize: "small"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* default */.Z, {
                checked: settings.theme === themes/* THEMES.DARK */.y.DARK,
                onChange: handleSwitch,
                name: "",
                color: "primary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Moon, {
                fontSize: "small"
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/constants/routes.ts
var routes = __webpack_require__(46648);
// EXTERNAL MODULE: ./src/hooks/useAuth.ts
var useAuth = __webpack_require__(78470);
// EXTERNAL MODULE: ./src/hooks/useSlugRouter.ts
var useSlugRouter = __webpack_require__(14794);
;// CONCATENATED MODULE: ./src/icons/Cog.tsx


var Cog = (0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        d: "M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z",
        clipRule: "evenodd"
    })
}), "Cog");
/* harmony default export */ var icons_Cog = (Cog);

;// CONCATENATED MODULE: ./src/utils/getInitials.ts
var getInitials = function() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return name.replace(/\s+/u, " ").split(" ").slice(0, 2).map(function(v) {
        return v.length > 0 ? v[0].toUpperCase() : "";
    }).join("");
};

;// CONCATENATED MODULE: ./src/utils/stringAvatar.ts

var stringToColor = function(string) {
    var hash = 0;
    for(var i = 0; i < string.length; i += 1){
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    var color = "#";
    for(var i1 = 0; i1 < 3; i1 += 1){
        var value = hash >> i1 * 8 & 255;
        color += "00".concat(value.toString(16)).substr(-2);
    }
    return color;
};
var stringAvatar = function() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return {
        sx: {
            bgcolor: stringToColor(name),
            height: 32,
            width: 32,
            fontSize: 15,
            fontWeight: 600
        },
        children: getInitials(name)
    };
};

;// CONCATENATED MODULE: ./src/components/dashboard/AccountPopover.tsx












function AccountPopover_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function AccountPopover_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                AccountPopover_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                AccountPopover_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function AccountPopover_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AccountPopover_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AccountPopover_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var AccountPopover = function() {
    var anchorRef = (0,react.useRef)(null);
    var router = (0,useSlugRouter/* useSlugRouter */.r)();
    var ref = (0,useAuth/* useAuth */.a)(), client = ref.client, logout = ref.logout;
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var handleOpen = function() {
        setOpen(true);
    };
    var handleClose = function() {
        setOpen(false);
    };
    var handleLogout = function() {
        var _ref = AccountPopover_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        handleClose();
                        _ctx.next = 4;
                        return logout();
                    case 4:
                        _ctx.next = 6;
                        return router.push(routes/* ROUTES.AUTH_LOGIN */.Z.AUTH_LOGIN);
                    case 6:
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        enqueueSnackbar(t("profile.popover_logout_failed.error"), {
                            variant: "error"
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function handleLogout() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref2, ref3;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: ButtonBase/* default */.Z,
                onClick: handleOpen,
                ref: anchorRef,
                sx: {
                    alignItems: "center",
                    display: "flex"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, AccountPopover_objectSpread({}, stringAvatar("".concat((ref2 = client === null || client === void 0 ? void 0 : client.firstname) !== null && ref2 !== void 0 ? ref2 : "", " ").concat((ref3 = client === null || client === void 0 ? void 0 : client.lastname) !== null && ref3 !== void 0 ? ref3 : ""))))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* default */.ZP, {
                anchorEl: anchorRef.current,
                anchorOrigin: {
                    horizontal: "center",
                    vertical: "bottom"
                },
                keepMounted: true,
                onClose: handleClose,
                open: open,
                PaperProps: {
                    sx: {
                        width: 240
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            p: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                color: "textPrimary",
                                variant: "subtitle2",
                                children: [
                                    client === null || client === void 0 ? void 0 : client.firstname,
                                    " ",
                                    client === null || client === void 0 ? void 0 : client.lastname
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeSwitcher, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            mt: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                            onClick: AccountPopover_asyncToGenerator(runtime_default().mark(function _callee() {
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            return _ctx.abrupt("return", router.push(routes/* ROUTES.PROFILE */.Z.PROFILE));
                                        case 1:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            })),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Cog, {
                                        fontSize: "small"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        color: "textPrimary",
                                        variant: "subtitle2",
                                        children: t("profile.popover_settings.label")
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            p: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            color: "primary",
                            fullWidth: true,
                            onClick: handleLogout,
                            variant: "outlined",
                            children: t("profile.popover_logout.button")
                        })
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/hooks/useInstanceData.ts
var useInstanceData = __webpack_require__(22587);
;// CONCATENATED MODULE: ./src/icons/Menu.tsx


var Menu = (0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        d: "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
        clipRule: "evenodd"
    })
}), "Menu");
/* harmony default export */ var icons_Menu = (Menu);

// EXTERNAL MODULE: ./src/types/Tables.ts
var Tables = __webpack_require__(38708);
;// CONCATENATED MODULE: ./src/components/dashboard/DashboardNavbar.tsx















function DashboardNavbar_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function DashboardNavbar_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                DashboardNavbar_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                DashboardNavbar_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function DashboardNavbar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function DashboardNavbar_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            DashboardNavbar_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var DashboardNavbarRoot = (0,styled/* default */.ZP)(AppBar/* default */.Z)(function(param) {
    var theme = param.theme;
    return DashboardNavbar_objectSpread({}, theme.palette.mode === "light" && {
        backgroundColor: theme.palette.primary.main,
        boxShadow: "none",
        color: theme.palette.primary.contrastText
    }, theme.palette.mode === "dark" && {
        backgroundColor: theme.palette.background.paper,
        borderBottom: "1px solid ".concat(theme.palette.divider),
        boxShadow: "none"
    }, {
        zIndex: theme.zIndex.drawer + 100
    });
});
var LinkSyling = (0,styled/* default */.ZP)(Link/* default */.Z)(function(param) {
    var theme = param.theme;
    return DashboardNavbar_objectSpread({}, theme.palette.mode === "light" && {
        color: theme.palette.primary.contrastText
    }, theme.palette.mode === "dark" && {}, {
        color: theme.palette.primary.contrastText
    });
});
var DashboardNavbar = function(_param) {
    var onSidebarMobileOpen = _param.onSidebarMobileOpen, other = _objectWithoutProperties(_param, [
        "onSidebarMobileOpen"
    ]);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var permissions = (0,useAuth/* useAuth */.a)().permissions;
    var instance = (0,useInstanceData/* useInstanceData */.x)().instance;
    var seeResources = react.useMemo(function() {
        return permissions.actions.some(function(action) {
            return action.action_id === "resources:view_resources";
        });
    }, [
        permissions.actions
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        displayPrint: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardNavbarRoot, DashboardNavbar_objectSpread({}, other, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar/* default */.Z, {
                sx: {
                    minHeight: 64
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        sx: {
                            display: {
                                lg: "none",
                                xs: "flex"
                            },
                            mr: 1
                        },
                        color: "inherit",
                        onClick: onSidebarMobileOpen,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Menu, {
                            fontSize: "small"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                            alt: "FL Logo",
                            src: "/logos/flourish-logo.svg",
                            height: 26,
                            width: 230
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            flexGrow: 1,
                            ml: 2
                        }
                    }),
                    seeResources && /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundedButton/* RoundedButton */.z, {
                        color: "inherit",
                        onClick: DashboardNavbar_asyncToGenerator(runtime_default().mark(function _callee1() {
                            var _NEXT_PUBLIC_URL, resourcePDF;
                            return runtime_default().wrap(function _callee$(_ctx1) {
                                while(1)switch(_ctx1.prev = _ctx1.next){
                                    case 0:
                                        ;
                                        _ctx1.next = 3;
                                        return fetch("".concat((_NEXT_PUBLIC_URL = "https://flourishing-life-staging.aws.innovasium.com") !== null && _NEXT_PUBLIC_URL !== void 0 ? _NEXT_PUBLIC_URL : "", "/growthActionPlan/").concat((instance === null || instance === void 0 ? void 0 : instance.gap_type) === Tables/* GapTypes.FULL */.br.FULL ? "GrowthActionPlanGuide.pdf" : "GeneralGrowthActionPlanGuide.pdf")).then(function() {
                                            var _ref = DashboardNavbar_asyncToGenerator(runtime_default().mark(function _callee(tr) {
                                                return runtime_default().wrap(function _callee$(_ctx) {
                                                    while(1)switch(_ctx.prev = _ctx.next){
                                                        case 0:
                                                            return _ctx.abrupt("return", tr.blob());
                                                        case 1:
                                                        case "end":
                                                            return _ctx.stop();
                                                    }
                                                }, _callee);
                                            }));
                                            return function(tr) {
                                                return _ref.apply(this, arguments);
                                            };
                                        }());
                                    case 3:
                                        resourcePDF = _ctx1.sent;
                                        download_default()(resourcePDF, "resource.pdf", "application/pdf");
                                    case 5:
                                    case "end":
                                        return _ctx1.stop();
                                }
                            }, _callee1);
                        })),
                        children: t("nav_bar.resource.button")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundedButton/* RoundedButton */.z, {
                        color: "inherit",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkSyling, {
                            href: "https://www.youtube.com/playlist?list=PL5jh6wvheH-a-XOkHdKIT_u7Y1f9RhwoW",
                            rel: "noopener noreferrer",
                            target: "_blank",
                            children: t("nav_bar.help.button")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguagePopover, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            ml: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountPopover, {})
                    })
                ]
            })
        }))
    }));
};


// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 1 modules
var Drawer = __webpack_require__(58826);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListSubheader/ListSubheader.js + 1 modules
var ListSubheader = __webpack_require__(75438);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js + 4 modules
var ListItem = __webpack_require__(70891);
// EXTERNAL MODULE: ./node_modules/@mui/material/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(57922);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./src/icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(81653);
// EXTERNAL MODULE: ./src/icons/ChevronRight.tsx
var ChevronRight = __webpack_require__(50364);
;// CONCATENATED MODULE: ./src/components/NavItem.tsx






function NavItem_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function NavItem_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            NavItem_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var NavItem = function(param) {
    var _active = param.active, active = _active === void 0 ? false : _active, children = param.children, depth = param.depth, icon = param.icon, info = param.info, tmp = param.open, openProp = tmp === void 0 ? false : tmp, path = param.path, title = param.title;
    var ref = (0,react.useState)(openProp !== null && openProp !== void 0 ? openProp : false), open = ref[0], setOpen = ref[1];
    var handleToggle = function() {
        setOpen(function(prevOpen) {
            return !prevOpen;
        });
    };
    var paddingLeft = 1;
    var paddingY = 2;
    if (depth > 0) {
        paddingLeft = 1 + 2 * depth;
        paddingY = 1;
    }
    // Branch
    if (children) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.ZP, {
            disableGutters: true,
            sx: {
                display: "block",
                py: 0
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                    endIcon: !open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {
                        fontSize: "small"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown/* default */.Z, {
                        fontSize: "small"
                    }),
                    onClick: handleToggle,
                    startIcon: icon,
                    sx: {
                        color: "text.secondary",
                        fontWeight: "fontWeightMedium",
                        justifyContent: "flex-start",
                        pl: paddingLeft,
                        pr: "8px",
                        py: paddingY,
                        textAlign: "left",
                        textTransform: "none",
                        width: "100%"
                    },
                    variant: "text",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                flexGrow: 1
                            },
                            children: title
                        }),
                        info
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                    in: open,
                    children: children
                })
            ]
        }));
    }
    // Leaf
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
        disableGutters: true,
        sx: {
            display: "flex",
            py: 0
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
            href: path !== null && path !== void 0 ? path : "",
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                startIcon: icon,
                sx: NavItem_objectSpread({
                    color: "text.secondary",
                    fontWeight: "fontWeightMedium",
                    justifyContent: "flex-start",
                    pl: paddingLeft,
                    pr: "8px",
                    py: paddingY,
                    textAlign: "left",
                    textTransform: "none",
                    width: "100%",
                    borderRadius: 4
                }, active && {
                    color: "primary.main",
                    fontWeight: "fontWeightBold",
                    "& svg": {
                        color: "primary.main"
                    },
                    backgroundColor: "background.default"
                }),
                variant: "text",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            flexGrow: 1
                        },
                        children: title
                    }),
                    info
                ]
            })
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/NavSection.tsx





var ParentRoute = function(param) {
    var _depth = param.depth, depth = _depth === void 0 ? 0 : _depth, items = param.items, pathname = param.pathname, slug = param.slug, visibleKeys = param.visibleKeys;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(List/* default */.Z, {
        disablePadding: true,
        children: items.filter(function(item) {
            return visibleKeys.includes(item.key);
        }).map(function(item) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(ChildRoute, {
                item: item,
                pathname: pathname,
                depth: depth,
                slug: slug,
                visibleKeys: visibleKeys
            }, item.key);
        }, [])
    });
};
var ChildRoute = function(param) {
    var pathname = param.pathname, item = param.item, depth = param.depth, slug = param.slug, visibleKeys = param.visibleKeys;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    if (item.children) {
        if (!item.children.some(function(childItem) {
            return visibleKeys.includes(childItem.key);
        })) {
            return null;
        }
        var partialMatch = item.path ? pathname.includes(item.path) : false;
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
            active: partialMatch,
            depth: depth,
            icon: item.icon,
            info: item.info,
            open: partialMatch,
            path: slug ? "/".concat(slug).concat(String(item.path)) : String(item.path),
            title: t(item.title),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ParentRoute, {
                depth: depth + 1,
                items: item.children,
                pathname: pathname,
                slug: slug,
                visibleKeys: visibleKeys
            })
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
        active: item.path === pathname,
        depth: depth,
        icon: item.icon,
        info: item.info,
        path: slug ? "/".concat(slug).concat(String(item.path)) : String(item.path),
        title: t(item.title)
    }));
};
var NavSection = function(param) {
    var items = param.items, pathname = param.pathname, title = param.title, slug = param.slug, visibleKeys = param.visibleKeys;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(List/* default */.Z, {
        subheader: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListSubheader/* default */.Z, {
            disableGutters: true,
            disableSticky: true,
            sx: {
                color: "text.primary",
                fontSize: "0.75rem",
                lineHeight: 2.5,
                fontWeight: 700,
                textTransform: "uppercase"
            },
            children: title
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ParentRoute, {
            items: items,
            pathname: pathname,
            slug: slug,
            visibleKeys: visibleKeys
        })
    });
};
var NavCollection = function(param) {
    var sidebarRoutes = param.sidebarRoutes, visibleKeys = param.visibleKeys, pathname = param.pathname, slug = param.slug;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: sidebarRoutes.map(function(section) {
            var items = section.items.filter(function(item) {
                return visibleKeys.includes(item.key);
            });
            if (items.length === 0) {
                return null;
            }
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(NavSection, {
                pathname: pathname,
                sx: {
                    "& + &": {
                        mt: 3
                    }
                },
                items: items,
                title: t(section.title),
                slug: slug,
                visibleKeys: visibleKeys
            }, section.title));
        })
    }));
};

// EXTERNAL MODULE: ./src/components/loaders/SkeletonLoader.tsx
var SkeletonLoader = __webpack_require__(1356);
;// CONCATENATED MODULE: ./src/icons/ChartPie.tsx


var ChartPie = (0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    children: [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"
        })
    ]
}), "ChartPie");
/* harmony default export */ var icons_ChartPie = (ChartPie);

;// CONCATENATED MODULE: ./src/icons/ChartSquareBar.tsx


var ChartSquareBar = (0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        d: "M5 3a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zm9 4a1 1 0 10-2 0v6a1 1 0 102 0V7zm-3 2a1 1 0 10-2 0v4a1 1 0 102 0V9zm-3 3a1 1 0 10-2 0v1a1 1 0 102 0v-1z",
        clipRule: "evenodd"
    })
}), "ChartSquareBar");
/* harmony default export */ var icons_ChartSquareBar = (ChartSquareBar);

// EXTERNAL MODULE: ./src/icons/ClipboardList.tsx
var ClipboardList = __webpack_require__(10606);
;// CONCATENATED MODULE: ./src/icons/FolderOpen.tsx


var FolderOpen = (0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    children: [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            d: "M2 6a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1H8a3 3 0 00-3 3v1.5a1.5 1.5 0 01-3 0V6z",
            clipRule: "evenodd"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M6 12a2 2 0 012-2h8a2 2 0 012 2v2a2 2 0 01-2 2H2h2a2 2 0 002-2v-2z"
        })
    ]
}), "FolderOpen");
/* harmony default export */ var icons_FolderOpen = (FolderOpen);

// EXTERNAL MODULE: ./src/icons/Plus.tsx
var Plus = __webpack_require__(62919);
;// CONCATENATED MODULE: ./src/icons/ShoppingCart.tsx


var ShoppingCart = (0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
    })
}), "ShoppingCart");
/* harmony default export */ var icons_ShoppingCart = (ShoppingCart);

;// CONCATENATED MODULE: ./src/icons/Users.tsx


var Users = (0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"
    })
}), "Users");
/* harmony default export */ var icons_Users = (Users);

;// CONCATENATED MODULE: ./src/configs/sidebarRoutes.tsx









var createSidebarRoutes = function(customReportMenus, customTrendMenus) {
    return [
        {
            title: "leftnav.flourishing_life.header",
            items: [
                {
                    title: "leftnav.dashboard_section.title",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_ChartSquareBar, {
                        fontSize: "small"
                    }),
                    key: "dashboard",
                    path: routes/* ROUTES.DASHBOARD_ROOT */.Z.DASHBOARD_ROOT,
                    children: [
                        {
                            title: "leftnav.admin_dashboard.title",
                            path: routes/* ROUTES.DASHBOARD_ADMIN */.Z.DASHBOARD_ADMIN,
                            key: "admin_dashboard"
                        },
                        {
                            title: "leftnav.user_dashboard.title",
                            path: routes/* ROUTES.DASHBOARD_USER */.Z.DASHBOARD_USER,
                            key: "user_dashboard"
                        },
                        {
                            title: "leftnav.flourishing_profile.title",
                            path: routes/* ROUTES.FLOURISHING_PROFILE */.Z.FLOURISHING_PROFILE,
                            key: "flourishing_profile"
                        }, 
                    ]
                },
                {
                    title: "leftnav.reports.title",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_FolderOpen, {
                        fontSize: "small"
                    }),
                    key: "reports",
                    path: routes/* ROUTES.REPORTS_ROOT */.Z.REPORTS_ROOT,
                    children: [
                        {
                            title: "leftnav.flourishing_summary.title",
                            path: routes/* ROUTES.REPORTS_FLOURISHING_SUMMARY */.Z.REPORTS_FLOURISHING_SUMMARY,
                            key: "reports_flourishing_summary"
                        },
                        {
                            title: "leftnav.flourishing_mindset.title",
                            path: routes/* ROUTES.REPORTS_FLOURISHING_MINDSETS */.Z.REPORTS_FLOURISHING_MINDSETS,
                            key: "reports_flourishing_mindsets"
                        },
                        {
                            title: "leftnav.resilience_capacity.title",
                            path: routes/* ROUTES.REPORTS_RESILIENCE_CAPACITY */.Z.REPORTS_RESILIENCE_CAPACITY,
                            key: "reports_resiliency_capacity"
                        },
                        {
                            title: "leftnav.performance_capacity.title",
                            path: routes/* ROUTES.REPORTS_PERFORMANCE_CAPACITY */.Z.REPORTS_PERFORMANCE_CAPACITY,
                            key: "reports_performance_capacity"
                        },
                        {
                            title: "leftnav.well_being_factors.title",
                            path: routes/* ROUTES.REPORTS_SEVEN_WELL_BEING_FACTORS */.Z.REPORTS_SEVEN_WELL_BEING_FACTORS,
                            key: "reports_seven_well_being"
                        },
                        {
                            title: "leftnav.core_competencies.title",
                            path: routes/* ROUTES.REPORTS_CORE_COMPETENCY */.Z.REPORTS_CORE_COMPETENCY,
                            key: "reports_core_competency"
                        },
                        {
                            title: "leftnav.nine_habits.title",
                            path: routes/* ROUTES.REPORTS_NINE_HABITS */.Z.REPORTS_NINE_HABITS,
                            key: "reports_nine_habits"
                        },
                        {
                            title: "leftnav.custom_questions.title",
                            path: routes/* ROUTES.REPORTS_CUSTOM_QUESTIONS */.Z.REPORTS_CUSTOM_QUESTIONS,
                            key: "reports_custom_questions"
                        },
                        {
                            title: "leftnav.client_list.title",
                            path: routes/* ROUTES.REPORTS_CLIENT_LIST */.Z.REPORTS_CLIENT_LIST,
                            key: "reports_client_list"
                        },
                        {
                            title: "custom_reports.title.label",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_FolderOpen, {
                                fontSize: "small"
                            }),
                            key: "reports",
                            path: routes/* ROUTES.REPORTS_ROOT */.Z.REPORTS_ROOT,
                            children: customReportMenus.map(function(menu) {
                                return {
                                    title: menu.name,
                                    path: "".concat(routes/* ROUTES.REPORTS_CUSTOM_BASE */.Z.REPORTS_CUSTOM_BASE, "?custom_report_id=").concat(menu.custom_report_id),
                                    key: menu.custom_menu_id
                                };
                            })
                        }, 
                    ]
                },
                {
                    title: "leftnav.trends.title",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_FolderOpen, {
                        fontSize: "small"
                    }),
                    key: "trends",
                    path: routes/* ROUTES.REPORTS_ROOT */.Z.REPORTS_ROOT,
                    children: [
                        {
                            title: "leftnav.trends.flourishing_summary",
                            path: routes/* ROUTES.TRENDS_FLOURISHING_SUMMARY */.Z.TRENDS_FLOURISHING_SUMMARY,
                            key: "trends_flourishing_summary"
                        },
                        {
                            title: "leftnav.trends.flourishing_mindset",
                            path: routes/* ROUTES.TRENDS_FLOURISHING_MINDSET */.Z.TRENDS_FLOURISHING_MINDSET,
                            key: "trends_flourishing_mindset"
                        },
                        {
                            title: "leftnav.trends.resilience_capacity",
                            path: routes/* ROUTES.TRENDS_RESILIENCE_CAPACITY */.Z.TRENDS_RESILIENCE_CAPACITY,
                            key: "trends_resiliency_capacity"
                        },
                        {
                            title: "leftnav.trends.performance_capacity",
                            path: routes/* ROUTES.TRENDS_PERFORMANCE_CAPACITY */.Z.TRENDS_PERFORMANCE_CAPACITY,
                            key: "trends_performance_capacity"
                        },
                        {
                            title: "leftnav.trends.seven_well_being_factors",
                            path: routes/* ROUTES.TRENDS_SEVEN_WELL_BEING_FACTORS */.Z.TRENDS_SEVEN_WELL_BEING_FACTORS,
                            key: "trends_seven_well_being_factors"
                        },
                        {
                            title: "leftnav.trends.core_competency",
                            path: routes/* ROUTES.TRENDS_CORE_COMPETENCY */.Z.TRENDS_CORE_COMPETENCY,
                            key: "trends_core_competency"
                        },
                        {
                            title: "leftnav.trends.nine_habits",
                            path: routes/* ROUTES.TRENDS_NINE_HABITS */.Z.TRENDS_NINE_HABITS,
                            key: "trends_nine_habits"
                        },
                        {
                            title: "Custom Trend Reports",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_FolderOpen, {
                                fontSize: "small"
                            }),
                            key: "trends",
                            path: routes/* ROUTES.REPORTS_ROOT */.Z.REPORTS_ROOT,
                            children: customTrendMenus.map(function(menu) {
                                return {
                                    title: menu.name,
                                    path: "".concat(routes/* ROUTES.TRENDS_CUSTOM_BASE */.Z.TRENDS_CUSTOM_BASE, "?custom_report_id=").concat(menu.custom_report_id),
                                    key: menu.custom_menu_id
                                };
                            })
                        }, 
                    ]
                }, 
            ]
        },
        {
            title: "leftnav.questionnaire.header",
            items: [
                {
                    title: "leftnav.assign_questionnaire.title",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Plus/* default */.Z, {
                        fontSize: "small"
                    }),
                    path: routes/* ROUTES.TESTS_ASSIGN */.Z.TESTS_ASSIGN,
                    key: "clients_assign"
                },
                {
                    title: "leftnav.questionnaire_status.title",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_ChartPie, {
                        fontSize: "small"
                    }),
                    path: routes/* ROUTES.TESTS_STATUS */.Z.TESTS_STATUS,
                    key: "questionnaire_status"
                },
                {
                    title: "leftnav.list_questionnaire.title",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClipboardList/* default */.Z, {
                        fontSize: "small"
                    }),
                    path: routes/* ROUTES.TESTS_LIST */.Z.TESTS_LIST,
                    key: "survey_admin_list"
                },
                {
                    title: "Custom Report Builder",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_FolderOpen, {
                        fontSize: "small"
                    }),
                    path: routes/* ROUTES.CUSTOM_REPORTS */.Z.CUSTOM_REPORTS,
                    key: "custom_reports"
                }, 
            ]
        },
        {
            title: "leftnav.client_management.header",
            items: [
                {
                    title: "leftnav.user_manager.title",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Users, {
                        fontSize: "small"
                    }),
                    path: routes/* ROUTES.CLIENT_MANAGER */.Z.CLIENT_MANAGER,
                    key: "client_manager"
                },
                {
                    title: "leftnav.join_code.title",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClipboardList/* default */.Z, {
                        fontSize: "small"
                    }),
                    path: routes/* ROUTES.CLIENT_JOIN_CODE */.Z.CLIENT_JOIN_CODE,
                    key: "join_code"
                }, 
            ]
        },
        {
            title: "leftnav.admin.header",
            items: [
                {
                    title: "leftnav.org_manager.title",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Users, {
                        fontSize: "small"
                    }),
                    path: routes/* ROUTES.INSTANCE_LIST */.Z.INSTANCE_LIST,
                    key: "instance_manager"
                },
                {
                    title: "leftnav.licence_manager.title",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_ShoppingCart, {
                        fontSize: "small"
                    }),
                    path: routes/* ROUTES.LICENSE_MANAGER */.Z.LICENSE_MANAGER,
                    key: "license_manager"
                }, 
            ]
        }, 
    ];
};

;// CONCATENATED MODULE: ./src/icons/Logo.tsx


function Logo_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Logo_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Logo_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var LogoRoot = (0,styled/* default */.ZP)("svg")(_templateObject());
var Logo = function(props) {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(LogoRoot, Logo_objectSpread({
        width: "229",
        height: "26",
        viewBox: "0 0 229 26"
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 23.8758V7.36967C0 6.80643 0.320849 6.49538 0.88982 6.49538H10.2971C10.8703 6.49538 11.1869 6.81064 11.1869 7.36967V7.49576C11.1869 8.059 10.8661 8.37003 10.2971 8.37003H2.07054V14.9565H9.83507C10.4083 14.9565 10.7249 15.2718 10.7249 15.8056V15.8897C10.7249 16.4361 10.404 16.7513 9.83507 16.7513H2.07054V23.88C2.07054 24.4433 1.74969 24.7543 1.18072 24.7543H0.88982C0.316571 24.7501 0 24.4349 0 23.8758Z",
                fill: "#888888"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.0654 23.8758V7.36967C14.0654 6.80643 14.3863 6.49538 14.9553 6.49538H15.2462C15.8194 6.49538 16.136 6.81064 16.136 7.36967V22.8629H23.8962C24.4695 22.8629 24.786 23.1781 24.786 23.7371V23.8758C24.786 24.4391 24.4652 24.7501 23.8962 24.7501H14.9553C14.382 24.7501 14.0654 24.4349 14.0654 23.8758Z",
                fill: "#888888"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.9834 15.6459C24.9834 9.13923 29.1031 6.28943 33.7276 6.28943C38.2708 6.28943 42.4333 9.13923 42.4333 15.6459C42.4333 22.2786 38.3007 25.0275 33.6762 25.0275C29.0518 25.0275 24.9834 22.2786 24.9834 15.6459ZM40.3584 15.6459C40.3584 10.9803 37.7917 8.17669 33.7276 8.17669C29.5993 8.17669 27.0326 10.9508 27.0326 15.6459C27.0326 20.4124 29.5095 23.1403 33.6762 23.1403C37.8259 23.1403 40.3584 20.4039 40.3584 15.6459Z",
                fill: "#888888"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M45.7402 16.1797V7.36967C45.7402 6.80643 46.0611 6.49538 46.6301 6.49538H46.921C47.4942 6.49538 47.8108 6.81064 47.8108 7.36967V16.1671C47.8108 21.1143 49.5733 23.1024 53.3336 23.1024C57.094 23.1024 58.8565 21.1143 58.8565 16.1797V7.36967C58.8565 6.80643 59.1774 6.49538 59.7463 6.49538H60.0372C60.6105 6.49538 60.9271 6.81064 60.9271 7.36967V16.1797C60.9271 22.2029 58.3218 25.0023 53.3336 25.0023C48.3455 25.0023 45.7402 22.2156 45.7402 16.1797Z",
                fill: "#888888"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M77.2434 24.7501H76.7514C76.2723 24.7501 75.9429 24.5652 75.6734 24.1869L71.2499 18.1678C70.8136 18.1888 70.3558 18.2015 69.881 18.2015H66.7709V23.8716C66.7709 24.4349 66.45 24.7459 65.8811 24.7459H65.5773C65.0041 24.7459 64.6875 24.4307 64.6875 23.8716V7.36546C64.6875 6.80223 65.0083 6.49118 65.5773 6.49118H69.9109C75.4851 6.49118 78.3129 7.84884 78.3129 12.3211C78.3129 15.6333 76.6402 17.2893 73.4787 17.9072L77.8038 23.6783C78.2829 24.3592 78.099 24.7501 77.2434 24.7501ZM76.2252 12.3883C76.2252 9.00893 73.9194 8.3112 69.8681 8.3112H66.758V16.4235H69.8681C73.9194 16.4235 76.2252 15.7678 76.2252 12.3883Z",
                fill: "#888888"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M95.1852 21.3329C94.8815 20.8369 95.0398 20.5132 95.6515 20.2652L95.8611 20.1812C96.3403 19.992 96.644 20.1055 97.0547 20.6688C98.2311 22.2534 100.255 23.1907 102.68 23.1907C105.602 23.1907 107.544 21.9003 107.544 19.8323C107.544 14.7842 95.6815 18.1804 95.6815 11.182C95.6815 8.27336 98.3894 6.22639 102.056 6.22639C105.072 6.22639 107.715 7.46214 108.935 9.50492C109.238 10.0093 109.076 10.3792 108.507 10.5599L108.229 10.6524C107.771 10.7911 107.446 10.6818 107.044 10.169C105.931 8.76515 104.34 8.0674 102.133 8.0674C99.4974 8.0674 97.6836 9.28635 97.6836 11.1862C97.6836 16.3772 109.563 12.7372 109.563 19.8617C109.563 22.9427 106.74 25.0065 102.689 25.0065C99.3263 25.0023 96.49 23.5564 95.1852 21.3329Z",
                fill: "#888888"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M112.318 23.8758V7.36967C112.318 6.80643 112.639 6.49538 113.208 6.49538H113.499C114.072 6.49538 114.389 6.81064 114.389 7.36967V14.553H124.596V7.36967C124.596 6.80643 124.917 6.49538 125.486 6.49538H125.777C126.35 6.49538 126.667 6.81064 126.667 7.36967V23.8758C126.667 24.4391 126.346 24.7501 125.777 24.7501H125.486C124.913 24.7501 124.596 24.4349 124.596 23.8758V16.373H114.389V23.8758C114.389 24.4391 114.068 24.7501 113.499 24.7501H113.208C112.639 24.7501 112.318 24.4349 112.318 23.8758Z",
                fill: "#888888"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M130.696 23.8758V7.36967C130.696 6.80643 131.017 6.49538 131.586 6.49538H131.877C132.45 6.49538 132.767 6.81064 132.767 7.36967V23.8758C132.767 24.4391 132.446 24.7501 131.877 24.7501H131.586C131.017 24.7501 130.696 24.4349 130.696 23.8758Z",
                fill: "#888888"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M136.78 23.8758V7.36967C136.78 6.80643 137.101 6.49538 137.67 6.49538H138.269C138.748 6.49538 139.095 6.6509 139.36 7.04601L149.939 21.6901V7.36967C149.939 6.80643 150.26 6.49538 150.829 6.49538H151.12C151.693 6.49538 152.01 6.81064 152.01 7.36967V23.8758C152.01 24.4391 151.689 24.7501 151.12 24.7501H150.594C150.115 24.7501 149.768 24.5946 149.503 24.1995L138.851 9.45448V23.8716C138.851 24.4349 138.53 24.7459 137.961 24.7459H137.67C137.101 24.7501 136.78 24.4349 136.78 23.8758Z",
                fill: "#888888"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M155.479 15.5702C155.479 9.99669 159.009 6.21378 164.185 6.21378C167.381 6.21378 169.858 7.33183 171.308 9.6268C171.646 10.1606 171.411 10.6188 170.799 10.7617L170.521 10.829C170.003 10.955 169.687 10.7953 169.366 10.3666C168.206 8.80297 166.534 8.0506 164.211 8.0506C160.219 8.0506 157.55 11.0391 157.55 15.587C157.55 20.2316 160.117 23.1361 164.172 23.1361C168.087 23.1361 170.487 20.8915 170.632 16.7639H165.126C164.553 16.7639 164.236 16.4487 164.236 15.8897V15.8056C164.236 15.2592 164.57 14.9565 165.126 14.9565H171.881C172.454 14.9565 172.771 15.1877 172.771 15.6837V16.1082C172.771 21.5893 169.443 24.9603 164.104 24.9603C158.855 24.9519 155.479 21.2698 155.479 15.5702Z",
                fill: "#888888"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M183.444 23.8758V7.36967C183.444 6.80643 183.765 6.49538 184.334 6.49538H184.625C185.198 6.49538 185.515 6.81064 185.515 7.36967V22.8629H193.275C193.848 22.8629 194.165 23.1781 194.165 23.7371V23.8758C194.165 24.4391 193.844 24.7501 193.275 24.7501H184.334C183.765 24.7501 183.444 24.4349 183.444 23.8758Z",
                fill: "#888888"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M196.894 23.8758V7.36967C196.894 6.80643 197.214 6.49538 197.783 6.49538H198.074C198.648 6.49538 198.964 6.81064 198.964 7.36967V23.8758C198.964 24.4391 198.643 24.7501 198.074 24.7501H197.783C197.214 24.7501 196.894 24.4349 196.894 23.8758Z",
                fill: "#888888"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M202.977 23.8758V7.36967C202.977 6.80643 203.297 6.49538 203.866 6.49538H213.274C213.847 6.49538 214.163 6.81064 214.163 7.36967V7.49576C214.163 8.059 213.843 8.37003 213.274 8.37003H205.047V14.9565H212.812C213.385 14.9565 213.701 15.2718 213.701 15.8056V15.8897C213.701 16.4361 213.381 16.7513 212.812 16.7513H205.047V23.88C205.047 24.4433 204.726 24.7543 204.157 24.7543H203.866C203.297 24.7501 202.977 24.4349 202.977 23.8758Z",
                fill: "#888888"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M217.043 23.8758V7.36967C217.043 6.80643 217.364 6.49538 217.933 6.49538H228.11C228.683 6.49538 229 6.81064 229 7.36967V7.50837C229 8.07161 228.679 8.38264 228.11 8.38264H219.113V14.553H227.648C228.221 14.553 228.538 14.8683 228.538 15.4273V15.5114C228.538 16.0746 228.217 16.373 227.648 16.373H219.113V22.8629H228.11C228.683 22.8629 229 23.1781 229 23.7371V23.8758C229 24.4391 228.679 24.7501 228.11 24.7501H217.933C217.364 24.7501 217.043 24.4349 217.043 23.8758Z",
                fill: "#888888"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M101.084 2.79531C101.084 2.79531 100.425 2.80791 99.7667 3.41738C99.1078 4.03106 98.3164 5.65351 96.7592 6.60765C95.2021 7.56179 93.8759 6.84724 93.4951 6.51098C93.1144 6.17052 93.3197 5.64091 93.3197 5.64091C93.3197 5.64091 92.4813 5.39292 93.0845 4.24963C95.8224 0.54236 101.084 2.79531 101.084 2.79531Z",
                fill: "#8CC640"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M96.7598 6.60887C98.1587 5.75141 98.9416 4.35173 99.5619 3.63297C98.8518 4.22983 97.9577 5.68836 96.3791 6.44495C94.9545 7.12588 93.7867 6.56684 93.2861 6.16753C93.3161 6.28523 93.376 6.41133 93.4915 6.5122C93.8808 6.85267 95.2027 7.56301 96.7598 6.60887Z",
                fill: "url(#paint0_linear)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M93.2904 4.75944C95.562 1.26653 100.191 2.53171 101.046 2.80072C101.072 2.80072 101.085 2.79652 101.085 2.79652C101.085 2.79652 95.5278 0.367039 93.0894 4.25085C92.8412 4.72161 92.8369 5.04106 92.9182 5.25122C92.9482 5.26803 92.9824 5.28484 93.0166 5.29745C93.1065 5.12091 93.2091 4.93177 93.2904 4.75944Z",
                fill: "url(#paint1_linear)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M72.9648 0.126755C72.9648 0.126755 73.8974 0.387356 74.6033 1.50542C75.3049 2.62349 75.8097 5.2337 77.6621 7.17561C79.5144 9.11751 81.6791 8.5921 82.355 8.25164C83.0267 7.91117 82.9411 7.07473 82.9411 7.07473C82.9411 7.07473 84.233 7.0327 83.8138 5.17487C81.3369 -1.13001 72.9648 0.126755 72.9648 0.126755Z",
                fill: "#8CC640"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M77.6626 7.17631C75.9942 5.42776 75.4209 3.1454 74.8135 1.88863C75.5921 3.00669 76.3108 5.41935 78.2658 7.08384C80.0326 8.5844 81.9149 8.22293 82.7833 7.83623C82.6935 7.99595 82.5609 8.14726 82.3556 8.25235C81.6796 8.59281 79.515 9.11822 77.6626 7.17631Z",
                fill: "url(#paint2_linear)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M83.3261 5.82708C81.4352 -0.00283524 74.3424 0.0770312 73.0162 0.144283C72.982 0.131674 72.9648 0.127467 72.9648 0.127467C72.9648 0.127467 81.8288 -1.26801 83.8095 5.17558C83.9806 5.93637 83.8651 6.39452 83.6684 6.66773C83.617 6.68034 83.5657 6.68874 83.5143 6.70135C83.4459 6.41132 83.3689 6.1087 83.3261 5.82708Z",
                fill: "url(#paint3_linear)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M96.1691 4.42319C96.1691 4.42319 89.7607 7.87407 88.4516 11.6612C87.8997 13.2542 86.9543 22.1693 86.5821 24.8216H86.3169C86.3169 24.8216 85.9447 13.6409 86.9072 10.7197C88.0666 7.19735 96.1691 4.42319 96.1691 4.42319Z",
                fill: "#888888"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M78.6211 3.6498C78.6211 3.6498 83.7461 7.68493 85.145 11.4342C85.7824 13.1407 85.9664 21.9339 86.0776 24.8216H86.3129C86.3129 24.8216 87.4252 14.759 86.8476 11.1022C86.2701 7.44533 78.6211 3.6498 78.6211 3.6498Z",
                fill: "#888888"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M87.2372 8.21033C88.3287 8.21033 89.2136 7.3409 89.2136 6.26842C89.2136 5.19593 88.3287 4.32652 87.2372 4.32652C86.1456 4.32652 85.2607 5.19593 85.2607 6.26842C85.2607 7.3409 86.1456 8.21033 87.2372 8.21033Z",
                fill: "#888888"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear",
                        x1: "96.9973",
                        y1: "2.931",
                        x2: "95.7592",
                        y2: "7.37115",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.1067",
                                stopColor: "#A8D15E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.4326",
                                stopColor: "#CFE28E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.9045",
                                stopColor: "#8DC640"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear",
                        x1: "98.46",
                        y1: "1.27153",
                        x2: "95.2979",
                        y2: "6.66123",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.0899",
                                stopColor: "#A8D15E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.309",
                                stopColor: "#CFE28E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.6742",
                                stopColor: "#8DC640"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear",
                        x1: "78.7301",
                        y1: "1.8146",
                        x2: "78.8423",
                        y2: "8.60776",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.1067",
                                stopColor: "#A8D15E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.4326",
                                stopColor: "#CFE28E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.9045",
                                stopColor: "#8DC640"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint3_linear",
                        x1: "77.2835",
                        y1: "-1.09684",
                        x2: "79.7705",
                        y2: "7.75234",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.0899",
                                stopColor: "#A8D15E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.309",
                                stopColor: "#CFE28E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.6742",
                                stopColor: "#8DC640"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var icons_Logo = (Logo);

;// CONCATENATED MODULE: ./src/components/dashboard/DashboardSidebar.tsx













function DashboardSidebar_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return DashboardSidebar_arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || DashboardSidebar_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function DashboardSidebar_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return DashboardSidebar_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return DashboardSidebar_arrayLikeToArray(o, minLen);
}
var DashboardSidebar = function(param) {
    var onMobileClose = param.onMobileClose, openMobile = param.openMobile;
    var ref = (0,useAuth/* useAuth */.a)(), client = ref.client, permissions = ref.permissions;
    var instance = (0,useInstanceData/* useInstanceData */.x)().instance;
    var settings = (0,useSettings/* useSettings */.r)().settings;
    var router = (0,useSlugRouter/* useSlugRouter */.r)();
    var ref1 = (0,dist/* default */.ZP)("custom-reports/custom-menus?language=".concat(settings.language)), customMenus = ref1.data, customMenuError = ref1.error;
    var accessibleKeys = react.useMemo(function() {
        return _toConsumableArray(permissions.menus.map(function(menu) {
            return menu.menu_id;
        })).concat(_toConsumableArray(permissions.customMenus.map(function(menu) {
            return menu.custom_menu_id;
        })));
    }, [
        permissions.customMenus,
        permissions.menus
    ]);
    var ref2, ref3;
    var sidebarRoutes = react.useMemo(function() {
        return createSidebarRoutes((ref2 = customMenus === null || customMenus === void 0 ? void 0 : customMenus.filter(function(menu) {
            return menu.type === Tables/* CustomMenuType.REPORT */.R9.REPORT;
        })) !== null && ref2 !== void 0 ? ref2 : [], (ref3 = customMenus === null || customMenus === void 0 ? void 0 : customMenus.filter(function(menu) {
            return menu.type === Tables/* CustomMenuType.TREND */.R9.TREND;
        })) !== null && ref3 !== void 0 ? ref3 : []);
    }, [
        customMenus
    ]);
    var ref4, _NEXT_PUBLIC_RELEASE_VERSION;
    var content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            display: "flex",
            flexDirection: "column",
            height: "100%",
            overflowY: "auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    justifyContent: "center",
                    p: 2,
                    display: {
                        lg: "none",
                        xs: "flex"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Logo, {
                    sx: {
                        height: 26,
                        width: 229
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    p: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        alignItems: "center",
                        backgroundColor: "background.default",
                        borderRadius: 1,
                        display: "flex",
                        overflow: "hidden",
                        p: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            ml: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                color: "textPrimary",
                                variant: "subtitle2",
                                children: [
                                    client === null || client === void 0 ? void 0 : client.firstname,
                                    " ",
                                    client === null || client === void 0 ? void 0 : client.lastname
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                color: "textSecondary",
                                variant: "body2",
                                children: "".concat((ref4 = instance === null || instance === void 0 ? void 0 : instance.instance_name) !== null && ref4 !== void 0 ? ref4 : "", " - ").concat((_NEXT_PUBLIC_RELEASE_VERSION = "2f9f808") !== null && _NEXT_PUBLIC_RELEASE_VERSION !== void 0 ? _NEXT_PUBLIC_RELEASE_VERSION : "local")
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    p: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonLoader/* SkeletonLoader */.g, {
                    loading: !customMenus,
                    error: customMenuError,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavCollection, {
                        visibleKeys: accessibleKeys,
                        sidebarRoutes: sidebarRoutes,
                        pathname: router.pathname.replace("/[slug]", ""),
                        slug: router.slug
                    })
                })
            })
        ]
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
                anchor: "left",
                onClose: onMobileClose,
                open: openMobile,
                PaperProps: {
                    sx: {
                        backgroundColor: "background.paper",
                        width: 280
                    }
                },
                sx: {
                    display: {
                        lg: "none",
                        xs: "block"
                    }
                },
                variant: "temporary",
                children: content
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
                anchor: "left",
                open: true,
                PaperProps: {
                    sx: {
                        backgroundColor: "background.paper",
                        height: "calc(100% - 64px) !important",
                        top: "64px !Important",
                        width: 280
                    }
                },
                sx: {
                    display: {
                        lg: "block",
                        xs: "none"
                    }
                },
                variant: "persistent",
                children: content
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Loading.tsx
var Loading = __webpack_require__(8080);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardHeader/CardHeader.js + 1 modules
var CardHeader = __webpack_require__(78445);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
// EXTERNAL MODULE: ./src/components/SlugLink.tsx
var SlugLink = __webpack_require__(44612);
;// CONCATENATED MODULE: ./src/components/SplashScreen.tsx




var SplashScreen = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            alignItems: "center",
            backgroundColor: "background.paper",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            justifyContent: "center",
            left: 0,
            p: 3,
            position: "fixed",
            top: 0,
            width: "100%",
            zIndex: 2000
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                    title: "Authentication Required"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            mt: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                color: "textSecondary",
                                variant: "subtitle2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        padding: 12
                                    },
                                    children: "Your session has expired, please log in to proceed."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SlugLink/* SlugLink */.$, {
                                href: routes/* ROUTES.AUTH_LOGIN */.Z.AUTH_LOGIN,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    color: "primary",
                                    fullWidth: true,
                                    size: "large",
                                    variant: "contained",
                                    children: "Log In"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/authentication/AuthenticatedRoute.tsx







var AuthenticatedRoute = function(param) {
    var children = param.children;
    var auth = (0,useAuth/* useAuth */.a)();
    var router = (0,next_router.useRouter)();
    var slug = router.query.slug;
    var cSlug = js_cookie/* default.get */.Z.get("slug");
    react.useEffect(function() {
        if (typeof slug === "string" && typeof cSlug === "string" && slug !== cSlug) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            router.push(router.route.replace("[slug]", cSlug));
        }
    }, [
        slug,
        cSlug,
        router
    ]);
    if (!auth.isInitialized) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* Loading */.g, {
            open: true
        }));
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: auth.isAuthenticated ? children : /*#__PURE__*/ (0,jsx_runtime.jsx)(SplashScreen, {})
    }));
};

;// CONCATENATED MODULE: ./src/components/dashboard/DashboardLayout.tsx







function DashboardLayout_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function DashboardLayout_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function DashboardLayout_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function DashboardLayout_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function DashboardLayout_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function DashboardLayout_slicedToArray(arr, i) {
    return DashboardLayout_arrayWithHoles(arr) || DashboardLayout_iterableToArrayLimit(arr, i) || DashboardLayout_unsupportedIterableToArray(arr, i) || DashboardLayout_nonIterableRest();
}
function DashboardLayout_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return DashboardLayout_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return DashboardLayout_arrayLikeToArray(o, minLen);
}
var DashboardLayoutRoot = (0,styled/* default */.ZP)("div")(function() {
    return {
        display: "flex",
        height: "100%",
        overflow: "hidden",
        width: "100%"
    };
});
var DashboardLayoutWrapper = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return DashboardLayout_defineProperty({
        display: "flex",
        flex: "1 1 auto",
        overflow: "hidden",
        paddingTop: "64px"
    }, theme.breakpoints.up("lg"), {
        paddingLeft: "280px"
    });
});
var DashboardLayoutContainer = (0,styled/* default */.ZP)("div")({
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden"
});
var DashboardLayoutContent = (0,styled/* default */.ZP)("div")({
    flex: "1 1 auto",
    height: "100%",
    overflow: "auto",
    position: "relative",
    WebkitOverflowScrolling: "touch"
});
var DashboardLayout = function(param) {
    var children = param.children, title = param.title;
    var isBaseStudent = (0,useAuth/* useAuth */.a)().isBaseStudent;
    var ref = DashboardLayout_slicedToArray(react.useState(false), 2), isSidebarMobileOpen = ref[0], setIsSidebarMobileOpen = ref[1];
    var handleMobileClose = function() {
        setIsSidebarMobileOpen(false);
    };
    var handleMobileOpen = function() {
        setIsSidebarMobileOpen(true);
    };
    if (!isBaseStudent) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthenticatedRoute, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        title,
                        " | Flourishing Life"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DashboardLayoutRoot, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardNavbar, {
                            onSidebarMobileOpen: handleMobileOpen
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardSidebar, {
                            onMobileClose: handleMobileClose,
                            openMobile: isSidebarMobileOpen
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardLayoutWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardLayoutContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardLayoutContent, {
                                    sx: {
                                        my: 3,
                                        mx: 3
                                    },
                                    children: children
                                })
                            })
                        })
                    ]
                })
            ]
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(AuthenticatedRoute, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DashboardLayoutRoot, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardNavbar, {
                    onSidebarMobileOpen: function() {
                        setIsSidebarMobileOpen(true);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardLayoutContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardLayoutContent, {
                        sx: {
                            my: 9,
                            mx: 3
                        },
                        children: children
                    })
                })
            ]
        })
    }));
};


/***/ }),

/***/ 1356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ SkeletonLoader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66242);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78445);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44267);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23972);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18979);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66684);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var useStyles = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    return {
        skeleton: {
            borderRadius: theme.shape.borderRadius
        },
        root: {
            transform: "none"
        }
    };
});
var SkeletonLoader = function(_param) {
    var loading = _param.loading, children = _param.children, _animation = _param.animation, animation = _animation === void 0 ? "wave" : _animation, _width = _param.width, width = _width === void 0 ? "100%" : _width, error = _param.error, props = _objectWithoutProperties(_param, [
        "loading",
        "children",
        "animation",
        "width",
        "error"
    ]);
    var classes = useStyles();
    if (error) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            sx: props.sx,
            "data-testid": "error-state",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    title: error.code
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body2",
                        children: error.message
                    })
                })
            ]
        }));
    }
    if (loading) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, _objectSpread({
            "data-testid": "loading-state",
            width: width,
            animation: animation,
            className: classes.skeleton,
            classes: {
                root: classes.root
            }
        }, props, {
            children: children
        })));
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    }));
};



/***/ }),

/***/ 46648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ROUTES; }
/* harmony export */ });
/**
 * Global routes table
 */ var ROUTES = {
    // Dashboard
    DASHBOARD_ROOT: "/dashboard",
    DASHBOARD_ADMIN: "/dashboard",
    DASHBOARD_USER: "/dashboard/user",
    TEST: "/dashboard/test",
    FLOURISHING_PROFILE: "/dashboard/flourishing-profile",
    // Auth
    AUTH_LOGIN: "/authentication/login",
    AUTH_FORGOT_PASSWORD: "/authentication/forgot-password",
    AUTH_CHANGE_PASSWORD: "/authentication/change-password",
    AUTH_RESET_PASSWORD: "/authentication/forgot-password-reset",
    AUTH_VERIFY_MFA: "/authentication/verify-mfa",
    AUTH_REGISTER: "/join-code/register",
    AUTH_JOIN_CODE: "/join-code",
    AUTH_UNIQUE_ID: "/join-code/unique-id",
    // Test management
    TESTS_ASSIGN: "/tests/assign",
    TESTS_EDIT: "/tests/edit",
    TESTS_LIST: "/tests",
    TESTS_CREATE: "/tests/create",
    TESTS_STATUS: "/tests/status",
    TESTS_NO_TEST: "/tests/no-test",
    TESTS_COMPLETED_TEST: "/tests/completed-test",
    CUSTOM_REPORTS: "/tests/custom-reports",
    CUSTOM_REPORTS_VIEW_SINGLE: "/tests/custom-reports/view",
    CUSTOM_REPORTS_CREATE: "/tests/custom-reports/create",
    // Client management
    CLIENT_ROOT: "/clients",
    CLIENT_JOIN_CODE: "/clients/join-code",
    CLIENT_MANAGER: "/clients",
    CLIENT_CREATE: "/clients/create",
    CLIENT_VIEW_SINGLE: "/clients/view",
    // Reports
    REPORTS_ROOT: "/reports",
    REPORTS_CORE_COMPETENCY: "/reports/core-competency",
    REPORTS_NINE_HABITS: "/reports/nine-habits",
    REPORTS_CUSTOM_QUESTIONS: "/reports/custom-questions-report",
    REPORTS_FLOURISHING_MINDSETS: "/reports/flourishing-mindsets",
    REPORTS_PERFORMANCE_CAPACITY: "/reports/performance-capacity",
    REPORTS_RESILIENCE_CAPACITY: "/reports/resiliency-capacity",
    REPORTS_SEVEN_WELL_BEING_FACTORS: "/reports/seven-well-being-factors",
    REPORTS_FLOURISHING_SUMMARY: "/reports/flourishing-summary",
    REPORTS_CLIENT_LIST: "/reports/client-list",
    REPORTS_CUSTOM_BASE: "/reports/custom-report-base",
    // Trend views
    TRENDS_RESILIENCE_CAPACITY: "/trends/resiliency-capacity",
    TRENDS_PERFORMANCE_CAPACITY: "/trends/performance-capacity",
    TRENDS_SEVEN_WELL_BEING_FACTORS: "/trends/seven-well-being-factors",
    TRENDS_CORE_COMPETENCY: "/trends/core-competency",
    TRENDS_FLOURISHING_MINDSET: "/trends/flourishing-mindset",
    TRENDS_NINE_HABITS: "/trends/nine-habits",
    TRENDS_FLOURISHING_SUMMARY: "/trends/flourishing-summary",
    TRENDS_CUSTOM_BASE: "/trends/custom-trend-base",
    // FL Admin
    LICENSE_MANAGER: "/fl-admin/license-manager",
    INSTANCE_EDIT: "/fl-admin/organization-manager/edit",
    INSTANCE_CREATE: "/fl-admin/organization-manager/create",
    INSTANCE_LIST: "/fl-admin/organization-manager",
    // Misc
    UNAUTHORIZED: "/unauthorized",
    PROFILE: "/profile"
};


/***/ }),

/***/ 22587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useInstanceData; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var contexts_InstanceContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58418);


var useInstanceData = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(contexts_InstanceContext__WEBPACK_IMPORTED_MODULE_1__/* .InstanceContext */ .j);
};


/***/ }),

/***/ 81653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82066);


var ChevronDown = (0,_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
        clipRule: "evenodd"
    })
}), "ChevronDown");
/* harmony default export */ __webpack_exports__["Z"] = (ChevronDown);


/***/ }),

/***/ 50364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82066);


var ChevronRight = (0,_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
        clipRule: "evenodd"
    })
}), "ChevronRight");
/* harmony default export */ __webpack_exports__["Z"] = (ChevronRight);


/***/ }),

/***/ 10606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82066);


var ClipboardList = (0,_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    children: [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            d: "M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z",
            clipRule: "evenodd"
        })
    ]
}), "ClipboardList");
/* harmony default export */ __webpack_exports__["Z"] = (ClipboardList);


/***/ }),

/***/ 62919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82066);


var Plus = (0,_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        d: "M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z",
        clipRule: "evenodd"
    })
}), "Plus");
/* harmony default export */ __webpack_exports__["Z"] = (Plus);


/***/ }),

/***/ 38708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ht": function() { return /* binding */ AnonymityLevel; },
/* harmony export */   "j9": function() { return /* binding */ OverrideStatus; },
/* harmony export */   "aJ": function() { return /* binding */ CustomReportComplexity; },
/* harmony export */   "js": function() { return /* binding */ CustomReportType; },
/* harmony export */   "R9": function() { return /* binding */ CustomMenuType; },
/* harmony export */   "br": function() { return /* binding */ GapTypes; },
/* harmony export */   "ZA": function() { return /* binding */ TrendGraphTypes; }
/* harmony export */ });
/* unused harmony exports ACTION_SCOPES, MENU_SCOPES */
var ACTION_SCOPES = (/* unused pure expression or super */ null && ([
    "reports:view_self",
    "reports:view_aggregate",
    "clients:list_clients",
    "clients:add_client",
    "instance:manage_instance",
    "instance:create_instance",
    "instance:manage_own_instance",
    "licenses:view_licenses",
    "licenses:modify_licenses",
    "tests:take_test",
    "tests:assign_remove_test",
    "tests:delete_test",
    "account:manage_account",
    "clients:edit_clients",
    "tests:create_test",
    "tests:edit_test",
    "tests:view_status",
    "action_plan:create_action_plan",
    "action_plan:edit_action_plan",
    "action_plan:delete_action_plan",
    "resources:view_resources",
    "resources:view_summary_report",
    "reports:view_gap",
    "custom_reports:create_custom_report",
    "custom_reports:get_custom_reports",
    "custom_reports:manage_all",
    "custom_reports:manage_own",
    "custom_reports:manage_complexity",
    "join_code:manage", 
]));
var AnonymityLevel;
(function(AnonymityLevel) {
    AnonymityLevel["FULL"] = "FULL";
    AnonymityLevel["PARTIAL"] = "PARTIAL";
    AnonymityLevel["NONE"] = "NONE";
})(AnonymityLevel || (AnonymityLevel = {}));
var MENU_SCOPES = (/* unused pure expression or super */ null && ([
    "dashboard",
    "admin_dashboard",
    "user_dashboard",
    "instance_manager",
    "reports",
    "reports_resiliency_capacity",
    "clients",
    "reports_performance_capacity",
    "reports_flourishing_mindsets",
    "reports_core_competency",
    "reports_nine_habits",
    "reports_seven_well_being",
    "reports_custom_questions",
    "reports_client_list",
    "trends",
    "trends_resiliency_capacity",
    "trends_performance_capacity",
    "trends_seven_well_being_factors",
    "trends_core_competency",
    "trends_flourishing_mindset",
    "trends_nine_habits",
    "trends_flourishing_summary",
    "clients_assign",
    "clients_create",
    "clients_tree",
    "survey_admin",
    "survey_admin_list",
    "edit_language",
    "flourishing_profile",
    "license_manager",
    "client_manager",
    "reports_flourishing_summary",
    "questionnaire_status",
    "anonymity_override",
    "custom_reports",
    "join_code", 
]));
var OverrideStatus;
(function(OverrideStatus) {
    OverrideStatus["Denied"] = "DENIED";
    OverrideStatus["Requested"] = "REQUESTED";
    OverrideStatus["Accepted"] = "ACCEPTED";
})(OverrideStatus || (OverrideStatus = {}));
var CustomReportComplexity;
(function(CustomReportComplexity) {
    CustomReportComplexity["simple"] = "SIMPLE";
    CustomReportComplexity["full"] = "FULL";
})(CustomReportComplexity || (CustomReportComplexity = {}));
var CustomReportType;
(function(CustomReportType) {
    CustomReportType["individual"] = "INDIVIDUAL";
    CustomReportType["aggregate"] = "AGGREGATE";
})(CustomReportType || (CustomReportType = {}));
var CustomMenuType;
(function(CustomMenuType) {
    CustomMenuType["REPORT"] = "REPORT";
    CustomMenuType["TREND"] = "TREND";
})(CustomMenuType || (CustomMenuType = {}));
var GapTypes;
(function(GapTypes) {
    GapTypes["STANDARD"] = "STANDARD";
    GapTypes["FULL"] = "FULL";
})(GapTypes || (GapTypes = {}));
var TrendGraphTypes;
(function(TrendGraphTypes) {
    TrendGraphTypes["SIMPLE"] = "SIMPLE";
    TrendGraphTypes["COMPLEX"] = "COMPLEX";
})(TrendGraphTypes || (TrendGraphTypes = {}));


/***/ })

}]);